import React from 'react';
import {Mixin as FormsyMixin} from 'formsy-react';
import ComponentMixin from 'formsy-react-components/release/mixins/component';
import {Row} from 'formsy-react-components';
import * as Instanced from '../../standalone/instanceHelper';
import ReactSelect, { createFilter } from 'react-select';
import Token from '../../../packages/extension/src/background/Token';
import Input from './Input.react';
import {FormattedMessage, IntlShape} from 'react-intl';
import SafeHTML from '../fw/SafeHTML.react';

// eslint-disable-next-line
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/prop-types */

let SelectBox = React.createClass({
    displayName: 'Dictionary',

    mixins: [FormsyMixin, ComponentMixin],

    componentDidMount: function () {
        let secondIsCombobox = this.props.datiQuery2 || this.props.channel2_id;
        setTimeout(() => {
            let st = {
                fetching: true,
                loading: true,
                loading1: true,
                loading2: true,
            };

            if (!secondIsCombobox) {
                st['list2'] = [];
                st['isInput2'] = true;
                st['loading2'] = false;
            }

            this.setState(st);
        });

        Promise.all([
            this.startFetch(this.props.datiQuery, this.props.channel_id, true, true).then((result) => {
                this.setState({
                    "list1": result,
                    loading1: false,
                });
            }),
            secondIsCombobox ? this.startFetch(this.props.datiQuery2, this.props.channel2_id, false, false).then((result) => {
                this.setState({
                    "list2": result,
                    loading2: false,
                });
            }) : null,
        ]).then(() => {
            setTimeout(() => {
                this.setState({
                    fetched: true,
                    loading: false,
                });
            });
        }).catch(() => {
            this.setState({
                loading: false,
                error: true,
                loading1: false,
            });
        });
    },

    changeValue: function changeValue(key, item) {
        let values = this.getValue() || {};
        values[key] = item.value;
        this.setValue(values);
        this.props.onChange(this.props.name, values);
    },

    startFetch: function (datiQuery, channelId, isKey, isFirst = false) {
        let organisationId = this.props.organisation_id;
        let flowId = this.props.flow_id;

        let error = (e) => {
            this.setState({
                error: true,
                errorMessage: e ? e.message : undefined,
                loading: false,
            });
        };

        if (!organisationId) {
            error("Missing organisation_id for datiQuery");
            throw new Error("Missing organisation_id for datiQuery: " + datiQuery);
        }
        if (!channelId) {
            error("Missing channel_id for datiQuery");
            throw new Error("Missing channel_id for datiQuery: " + datiQuery);
        }

        let url = "/api/v1/datiquery?query=" + encodeURIComponent(datiQuery) + "&organisationId=" + encodeURIComponent(organisationId || '') + "&channelId=" + encodeURIComponent(channelId || '') + "&flowId=" + encodeURIComponent(flowId || '');

        let promise;
        if (this.props.fetchingCache[url]) {
            promise = this.props.fetchingCache[url];
        } else {
            promise = this.props.fetchingCache[url] = fetch(url, {
                headers: {
                    "Authorization": "Bearer " + Token.get(),
                }
            }).then((result) => {
                return result.json();
            });
        }

        return promise.then((json) => {
            if (json.error) {
                return error(new Error(json.userError || json.errorMessage));
            }

            let values = [];
            let value = this.getValue() || {};

            for (let row of json.data) {
                let name = row['label'] || row['name'] || row["com.dativery.model.sharedFields.name@name"] || row["com.dativery.model.sharedFields.companyName@companyName"] || '';
                if (row["code"]) {
                    name = row["code"] + (name !== "" ? ": " + name : "");
                }

                let key = row["code"] || row.key;

                values.push({
                    label: name,
                    value: key,
                });
            }

            let matchingValue = Object.values(value || {});
            if (isKey) {
                matchingValue = Object.keys(value || {});
            }

            for (let val of matchingValue) {
                if (values.findIndex((a) => a.value === val) === -1) {
                    values.unshift({
                        label: val + " (Hodnota v seznamu chybí)",
                        value: val,
                    });
                }
            }

            if (!isFirst && !this.props.required) {
                values.unshift({
                    label: "-",
                    value: "",
                });
            }

            return values;
        }).catch((e) => {
            error(e);
        });
    },


    render: function render() {
        if (this.state.isInstanced && this.state.loading) {
            if (!this.state.loadingInstancedFunc) {
                setTimeout(() => {
                    if (this.__isMounted) {
                        this.setState({
                            loadingInstancedFunc: true
                        });
                    }
                });

                Instanced.getInstanceHelper().then((funcs) => {
                    this.instanceFuncs = funcs;

                    if (this.__isMounted) {
                        this.setState({
                            loadingInstancedFunc: false,
                            loading: false
                        });
                    }
                }).catch(() => {});
            }

            return null;
        }

        if (this.getLayout() === 'elementOnly') {
            return this.renderElement();
        }

        return React.createElement(
            Row,
            _extends({}, this.getRowProperties(), {
                htmlFor: this.getId()
            }),
            this.renderElement(),
            this.renderHelp(),
            this.renderErrorMessage()
        );
    },

    /**
     * @override Select.renderElement
     */
    renderElement: function renderElement() {
        let loading = false;
        let className = "";
        let htmlHelp = null;
        let help = null;

        if (this.props.htmlHelp) {
            htmlHelp = <span className="help-block"><SafeHTML value={this.props.htmlHelp + '<br/>'} /></span>;
        } else if (this.props.help) {
            help = <span className="help-block">{this.props.help}</span>;
        }

        if (this.state.loading) {
            className += ' datiquery-loading ';
            loading = true;
        }

        let values = this.getValue() || {};
        let list1 = (this.state.loading1 ? Object.keys(values).map((a) => ({value: a, label: a})) : this.state.list1) || [];

        const filterConfig = {
            ignoreCase: true,
            ignoreAccents: true,
            trim: true,
            matchFrom: 'any',
        };

        //let values = this.getValue() || {};
        let component = (<table className={className} style={{"width": "100%"}}>
            <colgroup>
                <col width="50%"/>
                <col width="50%"/>
            </colgroup>
            <thead>
                <tr>
                    <th>{this.props.channel && this.props.channel.channelDef ? this.props.channel.channelDef.name : ''}</th>
                    <th>{this.props.channel2 && this.props.channel2.channelDef ? this.props.channel2.channelDef.name : ''}</th>
                </tr>
            </thead>
            <tbody>
            {(list1 || []).map((value) => {
                let val = values[value.value];
                let list = this.state.list2 || [];
                let realValue = list.find((a) => a.value === val);
                return (<tr key={value.value}>
                    <td>{value.label}</td>
                    <td>
                        {this.state.loading2 ?
                            <div className="">{val}</div>
                        :
                            (this.state.isInput2 ?
                                <Input name={this.getId() + "-" + value.label + "-value"} onChange={(key, val, payload) => {
                                    if (value.value !== "") {
                                        this.changeValue(value.value, val);
                                    }
                                }} type="text" value={realValue}></Input>
                            :
                            <ReactSelect
                                className="searchable-select"
                                filterOption={createFilter(filterConfig)}
                                onChange={(item) => {
                                    if (value.value !== "") {
                                        this.changeValue(value.value, item);
                                    }
                                }}
                                options={list}
                                styles={{
                                    menu: (provided, state) => ({
                                        ...provided,
                                        'z-index': 100,
                                    }),
                                }}
                                value={realValue} />
                            )
                        }
                    </td>
                </tr>);
                })
            }</tbody>
        </table>);

        if (this.state.error) {
            return <div id={this.getId()}><div style={{position: "relative"}}><div style={{position: "absolute", "top": ".7em", "left": "-30px"}}><span className="fa fa-exclamation" style={{marginRight: '.3em', color: 'red'}}/></div><div>{component}{this.state.errorMessage ? <small style={{color: "red"}}><FormattedMessage defaultMessage="Error:" id="error"/> {this.state.errorMessage}</small> : null} {help}{htmlHelp}</div></div></div>;
        }

        if (loading) {
            return <div id={this.getId()}><div style={{position: "relative"}}><div style={{position: "absolute", "top": ".7em", "left": "-30px"}}><span className="fa fa-spin fa-refresh" style={{marginRight: '.3em'}}/></div><div>{component}{help}{htmlHelp}</div></div></div>;
        }

        return (<div id={this.getId()}>{component}{help}{htmlHelp}</div>);

    }
});

export default SelectBox;
